import { EMPTY_GENERAL_REPORT_MODEL } from "presentation/model/GeneralReport/GeneralReportModel";
import { useState } from "react";
import { createContainer } from "react-tracked";

const {
    Provider: GeneralReportProvider,
    useTracked: useGeneralReportTracked
} = createContainer(() => useState(EMPTY_GENERAL_REPORT_MODEL), {concurrentMode: true});
export { GeneralReportProvider, useGeneralReportTracked };
